import React, { ReactNode } from 'react';

interface FormFieldProps {
    label: string | ReactNode;
    id: string;
    required?: boolean;
    tooltip?: string;
    error?: string;
    children: ReactNode;
    className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
    label,
    id,
    required = false,
    tooltip,
    error,
    children,
    className = ''
}) => {
    const labelElement = (
        <span className={required ? "required" : ""}>
            <label htmlFor={id} className="reminder" data-tooltip-id="global-tooltip" data-tooltip-content={tooltip}>
                {label}
            </label>
        </span>
    );

    return (
        <>
            {/* Label */}
            <div className="col-xs-12 col-md-3">
                {labelElement}
            </div>
            
            {/* Input */}
            <div className={`col-xs-12 col-md-6 col-lg-3 ${className}`}>
                {children}
                {error && (
                    <small className="text-danger">{error}</small>
                )}
            </div>
            
            <div className="w-100"></div>
        </>
    );
};
